export default __webpack_public_path__ + "static/Badges3-c2039be3b7c8d7618fdd8b4390df5e87.svg";